import { registerLocaleData } from "@angular/common";
import { inject } from "@angular/core";
import { LocalStorageService } from "@kernel/tools/services/local-storage.service";

const locales = {
  en: () => import("@angular/common/locales/en"),
  nl: () => import("@angular/common/locales/nl"),
};

export const loadLocale = () => {
  const localStorage = inject(LocalStorageService);
  const lang = localStorage.get<"en" | "nl">("lang") || "nl";
  locales[lang]().then(d => registerLocaleData(d.default));
  return lang;
};
